import styled from "styled-components";

export const StyledInput = styled.div`
  display: flex;
  justify-content: center;

  input {
    border-radius: 10px;
    width: 100%;
    padding: 10px 100px 10px 30px;
    font: 400 20px Arial;
    border: 3px solid rgb(192, 25, 150);
  }
`;
